module.exports = __webpack_public_path__ + "img/14.e5abf860.png";